import React, { useRef, useState, useEffect } from "react";
import { Alert } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import L from "leaflet";
import {
  setLayersFromMaps,
  setActiveList,
  setBidangLayer,
} from "~/redux/actions";
import { TIPE_LAYER, TIPE_PETA } from "~/utils";
import EditLayer from "./edit";
import ListBidangItem from "./list-peta";
import LayoutPetaBidang from "~/layouts/peta";
import DynamicLayer from "~/components/DynamicLayer";
import TabPeta from "~/layouts/peta/TabsPeta";
import MapsCore from "~/components/MapsCore";
import request from "~/utils/request";

const PetaBidang = () => {
  const { desa } = useSelector((state) => state.Auth);
  const { urlFilter, allBidang, activeList, urlFilterByField, triggerRequest } =
    useSelector((state) => state.Map);

  const [loading, setLoading] = useState(false);
  const [editTabel, setEditTabel] = useState(false);
  const [detailInfo, setDetailInfo] = useState(null);
  const [activeLayer, setActiveLayer] = useState(null);

  const [bidangURL, setBidangURL] = useState("");

  const refs = useRef([]);

  const mapRef = useRef(null);
  const dispatch = useDispatch();
  const layerBidangRef = useRef(null);

  const handleDataLoaded = (datas) => {
    let layersArr = layerBidangRef?.current?.leafletElement?.getLayers();
    const centroidLayer = layersArr?.[0]?.getCenter();

    const getCurrentZoom = mapRef.current.leafletElement.getZoom();

    const isZoom = getCurrentZoom >= 18 ? getCurrentZoom : 18;

    if (datas) {
      layersArr = layersArr.filter((el) => {
        // properties = Object
        const { properties: properties1 } = el?.feature?.properties;
        return datas.some((elem) => {
          // properties = Object
          const { properties: properties2 } = elem;
          // check if datas in search same with data in layers
          return JSON.stringify(properties1) === JSON.stringify(properties2);
        });
      });
    }

    dispatch(setLayersFromMaps(layersArr));

    if (typeof centroidLayer !== "undefined") {
      mapRef.current.leafletElement.flyTo(
        new L.LatLng(centroidLayer?.lat, centroidLayer?.lng),
        isZoom
      );
    }
  };

  function handleChangeMode() {
    setEditTabel(!editTabel);
  }

  const handleClickItem = (layer) => {
    window.layer = layer;

    const getCurrentZoom = mapRef.current.leafletElement.getZoom();

    const isZoom = getCurrentZoom >= 18 ? getCurrentZoom : 18;

    // CHECKING TYPE GEOJSON
    if (layer?.feature?.geometry?.type === TIPE_LAYER.POINT) {
      mapRef.current.leafletElement.flyTo(
        new L.LatLng(layer?._latlng.lat, layer?._latlng.lng),
        isZoom
      );
      layer.bindTooltip(layer.feature.properties.properties.nama);
    } else {
      const centroid = layer.getBounds().getCenter();

      mapRef.current.leafletElement.flyTo(
        new L.LatLng(centroid.lat, centroid.lng),
        isZoom
      );

      layerBidangRef.current.leafletElement.resetStyle();

      setTimeout(() => {
        layer
          .bindTooltip(layer.feature.properties.properties.nama)
          .openTooltip();
        layer.setStyle({
          color: "black",
          weight: 7,
          opacity: 0.8,
          fillOpacity: 0.8,
        });
      }, 1);
    }

    setActiveLayer(layer);
    dispatch(setActiveList(layer));
  };

  async function getDetailInfo(layer) {
    setLoading(true);
    try {
      const response = await request.get(
        `/v1/sig/${layer.feature.properties.id}/detailinfo`
      );
      const responseData = await response.data.data;

      setDetailInfo(responseData);
    } finally {
      setLoading(false);
    }
  }

  function handleClickLayer(feature, layer) {
    handleClickItem(layer);
    getDetailInfo(layer);
    if (refs.current[layer.feature.properties.id]) {
      refs.current[layer.feature.properties.id].scrollIntoView({
        block: "start",
      });
    }
  }

  useEffect(() => {
    dispatch(setBidangLayer(TIPE_PETA.BIDANG));
  }, []);

  useEffect(() => {
    refs.current = refs.current.slice(0, ListBidangItem.length);
  }, [ListBidangItem]);

  useEffect(() => {
    if (!allBidang) {
      dispatch(setLayersFromMaps([]));
    }
  }, [allBidang]);

  useEffect(() => {
    if (urlFilter) {
      setBidangURL(`/v1/sig/stream/?filter{tipe.nama}=bidang${urlFilter}`);
    }
  }, [urlFilter]);

  useEffect(() => {
    if (allBidang) {
      setBidangURL(`/v1/sig/stream?filter{tipe.nama}=bidang`);
    }

    if (urlFilterByField) {
      setBidangURL(
        `/v1/sig/stream/?filter{tipe.nama}=bidang${urlFilterByField}`
      );
    }
  }, [allBidang, urlFilterByField]);

  return (
    <LayoutPetaBidang title={`PETA BIDANG DESA ${desa?.nama_desa}`}>
      <LayoutPetaBidang.LeftSidebar isOpen>
        <TabPeta isBidang handleSwitchMode={handleChangeMode}>
          <div className="mode-edit px-2 pb-2" />

          <div className="px-2">
            {activeList && (
              <Alert color="primary">
                <i className="mdi mdi-information-outline mr-2" />
                Bidang NBT {activeList?.feature?.properties?.properties?.nama}
              </Alert>
            )}

            <ul
              className="list-group"
              style={{ height: "calc(100vh - 170px)" }}
            >
              {!activeList ? (
                <div className="d-flex justify-content-center align-items-center mx-auto">
                  <p className="text-center">
                    Silahkan melakukan filter data terlebih dahulu sebelum
                    mendapatkan data bidang.
                  </p>
                </div>
              ) : (
                <ListBidangItem layer={activeList} />
              )}
            </ul>
          </div>
        </TabPeta>
      </LayoutPetaBidang.LeftSidebar>

      <LayoutPetaBidang.RightSidebar isOpen={editTabel && activeLayer}>
        {!!activeLayer && (
          <div>
            <EditLayer
              loading={loading}
              detailInfo={detailInfo}
              layer={activeLayer}
            />
          </div>
        )}
      </LayoutPetaBidang.RightSidebar>

      <MapsCore ref={mapRef}>
        {bidangURL !== "" && (
          <DynamicLayer
            filter
            bidang
            isTriggerByReducer
            url={bidangURL}
            ref={layerBidangRef}
            onDataLoaded={handleDataLoaded}
            onFeatureClick={handleClickLayer}
          />
        )}
      </MapsCore>
    </LayoutPetaBidang>
  );
};

export default PetaBidang;
